import axiosInstance from '@/plugins/api/axiosInstance';
import generateQueryParams from '@/utils/generateQueryParams';

export default function consolTypes() {
    return {
        index,
        create,
        update,
        getConsolTypeDetail,
        deleteConsolType
    };

    function index(options = {}) {
        const defaultValues = {
            pattern: '',
            limit: 25,
            page: 1
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`consolidated-type/search${params}`);
    }

    function getConsolTypeDetail(id) {
        return axiosInstance.get(`consolidated-type/get?id=${id}`);
    }

    function create(payload) {
        return axiosInstance.post(
            `consolidated-type/create`,
            JSON.stringify(payload)
        );
    }

    function update(payload) {
        return axiosInstance.patch(
            `consolidated-type/update`,
            JSON.stringify(payload)
        );
    }

    function deleteConsolType(payload) {
        return axiosInstance.delete(`consolidated-type/delete`, {
            data: JSON.stringify(payload)
        });
    }
}
